<div>
    <h4 class="mt-0">{{ getEudrRubrik() }}</h4>
    <div>
        <rask-label class="w-100 text-wrap mb-0">Gällande</rask-label>
    </div>
    <rask-row>
        <div class="col-md-6 ">
            <rask-input
                label="Referensnummer"
                [ngModel]="savedReferensnummer"
                [readonly]="true"
                placeholder="Inget sparat">
            </rask-input>
        </div>
        <div class="col-md-6">
            <rask-input
                label="Verifieringsnummer"
                [ngModel]="savedVerifieringsnummer"
                [readonly]="true"
                placeholder="Inget sparat">
            </rask-input>
        </div>
    </rask-row>


    <rask-cards class="p-2">
        <rask-card label="Uppdatera EUDR" >
            <div class="row g-3">
                <rask-input
                    class="col-md-6"
                    label="Referensnummer"
                    [(ngModel)]="arbetsorder.referensnummer"
                    (ngModelChange)="setReferensnummerVerifieringsnummer()">
                </rask-input>
                <rask-input
                    class="col-md-6"
                    label="Verifieringsnummer"
                    [(ngModel)]="arbetsorder.verifieringsnummer"
                    [rule]="validationContext.current.verifieringsnummer"
                    (ngModelChange)="setReferensnummerVerifieringsnummer()">
                </rask-input>
            </div>
        </rask-card>
    </rask-cards>

    @if (eudrAnmalan.items.length > 0) {
    <rask-toggle-panel class="mt-3" label="Historik">
        <rask-list [data]="eudrAnmalan.items">
                <rask-list-column header="Referensnummer" field="referens"></rask-list-column>
            <rask-list-column header="Verifieringsnummer" field="verifiering"></rask-list-column>
            <rask-list-column header="Verifierad" field="skickad">
                <ng-template let-row="row">
                    {{row.skickad | date: 'yyyy-MM-dd' }}
                </ng-template>
            </rask-list-column>
            <rask-list-column header="Status" field="status">
                <ng-template let-row="row">
                    {{row.status}}
                    @if(row.errors?.length > 0){
                    <rask-icon
                        popoverClass="popover-error popover-no-max-width"
                        icon="error fal fa-info-circle">
                        <div class="popover-message-container">
                            @for(error of row.errors; track error){
                            <div class="popover-message" #message>
                                {{error}}
                            </div>
                            }
                        </div>
                    </rask-icon>
                    }
                </ng-template>
            </rask-list-column>
        </rask-list>
    </rask-toggle-panel>
    }
</div>